export { default } from "./AddProductFormPrice"
